import React, { useEffect } from "react";
import "uikit/dist/css/uikit.min.css";
import "uikit/dist/js/uikit.min.js";
import "./dimensionsInput.css";

const DimensionsInput = ({ label, unit, isRafter, values, onChange }) => {
    const defaultSpacing = isRafter ? "400" : "400"; // Default value for radio buttons

    useEffect(() => {
        const spacingKey = isRafter ? "RafterSpacingCB" : "FloorJoistCentresEC";

        // If no value is selected, set the default
        if (!values[spacingKey]) {
            onChange({ target: { name: spacingKey, value: defaultSpacing } });
        }
    }, [isRafter, values, onChange]);

    const handleInputChange = (e) => {
        const { id, value, type, name } = e.target;

        if (type === "radio") {
            onChange({ target: { name, value: value.toString() } });
        } else if (/^\d*$/.test(value)) {
            onChange({ target: { name: id || name, value } });
        }
    };

    const handleKeyDown = (e) => {
        const invalidChars = ["e", "E", "+", "-"];
        if (invalidChars.includes(e.key)) {
            e.preventDefault();
        }
    };

    return (
        <div className="uk-child-width-1-1 uk-child-width-1-3@m uk-flex-middle uk-grid uk-grid-small uk-margin-small-bottom">
            <div className="uk-first-column">
                <label className="uk-form-label uk-display-block">{label}:</label>
            </div>

            <div className="dimension-input-container uk-width-2-3@m">
                <div className="input-container inline-inputs">
                    <div className="uk-flex dimension-input" style={{ width:"100%" }}>
                        <label style={{ display: "flex", alignItems: "center"}}>Width</label>
                        <input
                            id={isRafter ? "RafterWidthCB" : "FloorJoistWidthEC"}
                            value={isRafter ? values.RafterWidthCB || "" : values.FloorJoistWidthEC || ""}
                            type="number"
                            min={0}
                            inputMode="numeric"
                            onChange={handleInputChange}
                            onKeyDown={handleKeyDown}
                            className="dimension-input"
                        />
                    </div>
                    <div className="uk-flex dimension-input" style={{ width:"100%" }}>
                        <label style={{ display: "flex", alignItems: "center"}}>Depth</label>
                        <div>
                            <input
                                id={isRafter ? "RafterDepthCB" : "FloorJoistDepthEC"}
                                value={isRafter ? values.RafterDepthCB || "" : values.FloorJoistDepthEC || ""}
                                type="number"
                                min={0}
                                inputMode="numeric"
                                onChange={handleInputChange}
                                onKeyDown={handleKeyDown}
                                className="dimension-input"
                            />
                        </div>
                    </div>
                </div>

                <div className="input-container">
                    <div className="radio-group">
                        <div className="uk-width-1 uk-text-center" style={{ color: "#9ba2ad" }}>Spacings</div>
                        {isRafter ? (
                            <>
                                <label>
                                    <input
                                        type="radio"
                                        className="mobile-cat-radio"
                                        name="RafterSpacingCB"
                                        value="400"
                                        checked={values.RafterSpacingCB === "400"}
                                        onChange={handleInputChange}
                                    />
                                    400mm
                                </label>
                                <label>
                                    <input
                                        type="radio"
                                        className="mobile-cat-radio"
                                        name="RafterSpacingCB"
                                        value="450"
                                        checked={values.RafterSpacingCB === "450"}
                                        onChange={handleInputChange}
                                    />
                                    450mm
                                </label>
                                <label>
                                    <input
                                        type="radio"
                                        className="mobile-cat-radio"
                                        name="RafterSpacingCB"
                                        value="600"
                                        checked={values.RafterSpacingCB === "600"}
                                        onChange={handleInputChange}
                                    />
                                    600mm
                                </label>
                            </>
                        ) : (
                            <>
                                <label>
                                    <input
                                        type="radio"
                                        className="mobile-cat-radio"
                                        name="FloorJoistCentresEC"
                                        value="400"
                                        checked={values.FloorJoistCentresEC === "400"}
                                        onChange={handleInputChange}
                                    />
                                    400mm
                                </label>
                                <label>
                                    <input
                                        type="radio"
                                        className="mobile-cat-radio"
                                        name="FloorJoistCentresEC"
                                        value="600"
                                        checked={values.FloorJoistCentresEC === "600"}
                                        onChange={handleInputChange}
                                    />
                                    600mm
                                </label>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DimensionsInput;
